import { combineReducers } from 'redux'

import { socketSetupSuccess } from '@driftt/drift-ws'

import { AnyRootAction, createReducer } from 'typesafe-actions'

const setupComplete = createReducer<boolean, AnyRootAction>(false).handleAction(
  socketSetupSuccess,
  () => true
)

export default combineReducers({
  setupComplete,
})
